import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import { useLocation } from "@pomle/react-router-paths";
import { useVisitQuery } from "hooks/queries/useVisitQuery";
import { extendedVisitRecommendedScanStartTime } from "lib/extendedVisitRecommendedScanStartTime";
import { getSafeReturnPath } from "lib/getSafeReturnPath";
import { CheckInParams } from "lib/types/checkInParameters";
import { paths } from "render/routes/paths";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { ExtendedBloodDrawSteps } from "render/ui/presentation/ExtendedBloodDrawSteps";
import { Sangra75PilotTag } from "render/ui/presentation/Sangra75PilotTag";
import styles from "./styles.module.sass";

type ExtendedVisitBloodDrawIntroProps = {
  goTo(url: string): void;
  onBack(): void;
} & CheckInParams;

export function ExtendedVisitBloodDrawIntro({
  goTo,
  onBack,
  patientId,
  visitId,
}: ExtendedVisitBloodDrawIntroProps) {
  const { data: visit } = useVisitQuery({ patientId, visitId });
  const recommendedScanStartTime = visit
    ? extendedVisitRecommendedScanStartTime({
        startTime: visit.startTime,
        countryCode: visit.site.address.countryCode?.toUpperCase(),
      })
    : undefined;

  const location = useLocation();
  const nextUrl = getSafeReturnPath(
    location.searchParams.get("returnPath"),
    paths.extendedVisitLimsBloodDrawConfirm.url({ patientId, visitId })
  );

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <Sangra75PilotTag />
            <Typography variant="display-s">Extended Blood Test</Typography>
            <Typography variant="body-m" color="subtle">
              This visit is part of the extended blood test pilot. The member
              should have their blood drawn first, then be escorted to the
              reception and initiated into their scan routine at a later time.
            </Typography>
            <div className={styles.list}>
              <ExtendedBloodDrawSteps
                activeStep={1}
                recommendedScanStartTime={recommendedScanStartTime}
              />
            </div>
          </section>
        }
        buttons={
          <ActionsFooter
            left={
              <Button variant="secondary" onPress={onBack} fillContainer>
                Back
              </Button>
            }
            right={
              <Button
                onPress={() => goTo(nextUrl)}
                fillContainer
                icon={<Icon24ArrowRight />}
              >
                Continue
              </Button>
            }
          />
        }
      />
    </PageFrameContent>
  );
}
